import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Container, Form, Row, Image } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import NotyfContext from '../../contexts/NotyfContext';
import { fetchUploadedDocument, blankUploadDocument } from '../../redux/slices/UploadDocumentSlice';
import { Check } from 'react-feather';
import { createDisputeLatter, fetchNotification, setNotifcationBedge } from '../../redux/slices/CommonSlice';
import OnboardingSteps from '../../components/new/OnboardingSteps';
import AttemptMail from '../../assets/img/attempt-mail.png';

const TimeToMail = () => {
  const notyf = useContext(NotyfContext);
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Helmet title='Mailing Option' />

      <Container fluid className='p-0 container-fluid-1335'>
        <div className='row'>
          <div className='col-lg-12'>
            <h3>Disputes creating status</h3>
          </div>
        </div>
        <OnboardingSteps activeStepButtonLeft='-2px' progressComplete='920px' activeStep={5} />

        <Row>
          <Col xs='8' className='pt-5 py-4' style={{ margin: 'auto' }}>
            <Col lg='12' className='text-center pb-3'>
              <div className='h1'>Congratulations!</div>
              <p className='text-regular-18' style={{ color: 'var(--bs-dark-blue)' }}>
                Your disputes are being generated!
              </p>
            </Col>
            <Row>
              <Col lg='12' className='d-flex mx-auto'>
                <Image src={AttemptMail} fluid className='w-50 mx-auto' />
              </Col>
            </Row>
            <Row>
              <Col lg='12' className='d-flex flex-row justfity-content-between pt-5'>
                <Button variant='outline-primary' onClick={() => navigate('/upload-document')} className='px-5' type='button'>
                  Back
                </Button>
                <Button onClick={() => navigate('/mailing-option')} variant='primary ms-auto' className='px-5' type='submit' style={{ zIndex: '9999999999' }}>
                  Go to Print
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default TimeToMail;
